import { faCalendar } from '@fortawesome/free-regular-svg-icons';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TrustPilotWidget from '@website/components/trustpilot/TrustPilotWidget';
import { DateTime } from 'luxon';
import { ReactNode } from 'react';
import { Col, Row } from 'react-bootstrap';
import { GroupForBookingFormQuery } from '../../../types/graphqlOperations';
import BookingColumn from '../../directoryTheme/BookingColumn';
import { Image } from '../../media/utils/imgix';

/**
 * Booking form layout
 *
 * Creates the header and right column
 */
export default function PaymentFormLayout({
  group,
  children,
  showHeader = true,
  title = 'Step 1 of 2: Your Details',
}: {
  group: Pick<GroupForBookingFormQuery['group'], 'trip' | 'start' | 'end'>;
  children: ReactNode;
  showHeader?: boolean;
  title?: string;
}) {
  const { trip } = group;

  return (
    <>
      <Row>
        <Col md={7} className="mb-3 mt-3">
          {showHeader && (
            <div className="d-flex justify-content-between">
              <div>
                <p className="subtitle text-primary">{title}</p>
                <h1 className="h2 mb-0">{trip.title}</h1>
                <p className="mb-5">
                  <FontAwesomeIcon
                    icon={faCalendar}
                    className="fa-fw text-muted me-2"
                  />
                  {DateTime.fromISO(group.start.utc)
                    .setZone(group.start.zone)
                    .toLocaleString(DateTime.DATE_MED)}
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    className="fa-fw text-muted mx-2"
                  />
                  {DateTime.fromISO(group.end.utc)
                    .setZone(group.end.zone)
                    .toLocaleString(DateTime.DATE_MED)}
                </p>
              </div>

              <div className="d-md-none">
                <Image
                  imgKey={trip.image.file.key}
                  imgixParams={{
                    auto: 'compress,format,enhance,redeye',
                    crop: 'faces',
                    fit: 'crop',
                    ar: `1.5:1`, // Aspect ratio
                  }}
                  className="rounded shadow"
                  width={100}
                  height={75}
                />
              </div>
            </div>
          )}

          {children}
        </Col>

        <Col md={5} className="ps-xl-5 d-none d-md-block">
          <BookingColumn trip={trip} />

          <TrustPilotWidget
            templateId="5419b6ffb0d04a076446a9af"
            height="20px"
            className="my-4 d-none d-md-block"
          />
        </Col>
      </Row>
    </>
  );
}
